import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import SensorsIcon from '@mui/icons-material/Sensors';

const statusConfig = {
  Critical: { color: '#DC2626', bg: '#FEE2E2', border: '#FECACA' },
  Warning: { color: '#D97706', bg: '#FEF3C7', border: '#FDE68A' },
  Healthy: { color: '#2E7628', bg: '#DCFCE7', border: '#BBF7D0' },
};

const ConnectedSensors = ({ sensors }) => {
  return (
    <Card sx={{ borderRadius: 1, mb: 3 }}>
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SensorsIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: 'text.primary' }}>
              Sensor Outputs
            </Typography>
          </Box>
          {sensors.reportedTimestamp && (
            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', fontWeight: 500 }}>
              Last Reported: {sensors.reportedTimestamp}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', gap: 2.5 }}>
          {(sensors.items || []).map((sensor) => {
            const config = statusConfig[sensor.status] || statusConfig.Healthy;
            return (
              <Box
                key={sensor.id}
                sx={{
                  flex: 1,
                  p: 2,
                  borderRadius: 2,
                  border: '1px solid #E5E7EB',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                  <Typography sx={{ fontSize: '0.8125rem', color: '#6B7280' }}>
                    {sensor.label}
                  </Typography>
                  <Chip
                    label={sensor.status}
                    size="small"
                    sx={{
                      height: 22,
                      fontSize: '0.6875rem',
                      fontWeight: 600,
                      bgcolor: config.bg,
                      color: config.color,
                      border: `1px solid ${config.border}`,
                    }}
                  />
                </Box>

                <Typography sx={{ fontWeight: 700, fontSize: '1.75rem', color: '#1B2A3D', mb: 1 }}>
                  {sensor.value}
                  <Box component="span" sx={{ fontSize: '1rem', fontWeight: 500, ml: 0.25 }}>
                    {sensor.unit}
                  </Box>
                </Typography>

                <Box sx={{ display: 'flex', gap: 3 }}>
                  <Box>
                    <Typography sx={{ fontSize: '0.6875rem', color: '#9CA3AF' }}>Normal</Typography>
                    <Typography sx={{ fontSize: '0.75rem', color: '#6B7280', fontWeight: 500 }}>
                      {sensor.normalRange}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '0.6875rem', color: '#9CA3AF' }}>Critical</Typography>
                    <Typography sx={{ fontSize: '0.75rem', color: '#DC2626', fontWeight: 500 }}>
                      {sensor.criticalThreshold}
                    </Typography>
                  </Box>
                </Box>

              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ConnectedSensors;
